import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useNotificationList = (params?: any) => {
  return useQuery({
    queryKey: ['notification-list', params],
    queryFn: async () => {
      const res = await request.get('/notification', { params });
      return res.data;
    }
  });
};
